/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import { Dimensions, StyleSheet, Platform } from 'react-native';
const entireScreenHeight = Dimensions.get('window').height;


export default StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'black',
        marginBottom: Platform.OS === 'web'? 0: 90,
    },
      emptyListNoNetwork: {
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: entireScreenHeight/5,
      marginBottom: entireScreenHeight/5,
      padding: 40,
      backgroundColor: 'transparent',
      },
      emptyListNoNetworkText: {
      color: 'white',
      fontWeight: 'bold',
      marginTop: 10,
      },
      announcementContainer: {
      flexDirection: 'row',
      marginTop: 5,
      },
})